var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{class:_vm.classList,attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('span',{staticClass:"content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }